import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { pairDevice } from "../../../services/api";
import { Box } from "@mui/material";
import colors from "../../../theme";
import SnackbarComp from "../../../components/Snackbar/SnackbarComp";

const ChargingPointPairing = () => {
  const { chargePointId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    const pairAndNavigate = async () => {
      try {
        setIsLoading(true);
        const deviceData = { chargePointId };
        const response = await pairDevice(deviceData);

        if (response && response.success) {
          navigate("/devices", {
            state: {
              message: "Device paired successfully!",
              status: response.status || 400,
              redirect: true
            },
          });
        } else {
          navigate("/devices", {
            state: {
              message: response.message || "Failed to pair the device.",
              status: response.status || 400,
            },
          });
        }
      } catch (error) {
        console.error("Error during pairing:", error);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while pairing the device. Please try again.";
        const statusCode = error.response?.status || 500;

        setError(errorMessage);
        setStatusCode(statusCode);
        setOpenSnackbar(true);

        navigate("/devices", {
          state: {
            message: errorMessage,
            status: statusCode,
          },
        });
      } finally {
        setIsLoading(false);
      }
    };

    pairAndNavigate();
  }, [chargePointId, navigate]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <Box>
        {isLoading ? (
          <Box
            sx={{
              height: "100vh",
              backgroundColor: colors.mainContentBgColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Pairing your Device...
          </Box>
        ) : (
          <Box
            sx={{
              height: "100vh",
              backgroundColor: colors.mainContentBgColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Redirecting...
          </Box>
        )}
      </Box>
      <SnackbarComp
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        errorMessage={error}
        statusCode={statusCode}
      />
    </>
  );
};

export default ChargingPointPairing;
